import { ReactElement, useState } from 'react';
import { Link } from 'react-router-dom';

// Components.
import { Nav } from './Nav';
import { ProfileMenu } from './ProfileMenu';
import { Button, HelpIcon, ShopIcon } from '@comptia-sso/core';
import { PopupMenu } from './PopupMenu/PopupMenu';
import { PopupMenuItem } from './PopupMenu/PopupMenuItem';

// Hooks.
import { useTrackEvent } from 'hooks';
import { useTranslation } from 'react-i18next';

// Images.
import comptiaLogo from 'images/comptia-logo.png';

// Styles.
import styles from './Header.module.scss';
import { CertMasterEntryLink } from '../../components/CertMasterEntryLink';

export const Header = (): ReactElement => {
  const { t } = useTranslation();
  const trackEvent = useTrackEvent('Header');

  const handleEvent = () => {
    trackEvent('Clicked', { label: 'CompTIA Logo' });
  };

  const [activeMenu, setActiveMenu] = useState<string | undefined>(undefined);

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <Link onClick={handleEvent} to="/" className={styles.logo}>
          <img alt="CompTIA Logo" src={comptiaLogo} />
        </Link>
        <Nav />
        <CertMasterEntryLink />
        <Button
          className={styles.iconButton}
          link
          onClick={handleEvent}
          to="https://store.comptia.org"
          target="_blank"
          aria-label={t('FooterColumn-3.Title') as string}
        >
          <ShopIcon aria-hidden="true" />
        </Button>
        <Button
          className={styles.iconButton}
          onClick={() => setActiveMenu('helpMenu')}
          target="_blank"
          aria-label={t('NeedHelp.Title') as string}
        >
          <HelpIcon aria-hidden="true" />
        </Button>
        <PopupMenu
          isActive={activeMenu === 'helpMenu'}
          rightAligned
          onClose={() => setActiveMenu(undefined)}
        >
          {[
            <PopupMenuItem
              key={t('HelpMenu-Labels.Link-1') as string}
              label={t('HelpMenu-Labels.Link-1') as string}
              to={t('HelpMenu-Links.Link-1') as string}
              target="_blank"
              onClick={() => setActiveMenu(undefined)}
            />,
            <PopupMenuItem
              key={t('HelpMenu-Labels.Link-2') as string}
              label={t('HelpMenu-Labels.Link-2') as string}
              to={t('HelpMenu-Links.Link-2') as string}
              target="_blank"
              onClick={() => setActiveMenu(undefined)}
            />,
            <PopupMenuItem
              key={t('HelpMenu-Labels.Link-3') as string}
              label={t('HelpMenu-Labels.Link-3') as string}
              to={t('HelpMenu-Links.Link-3') as string}
              target="_blank"
              onClick={() => setActiveMenu(undefined)}
            />,
          ]}
        </PopupMenu>
        <ProfileMenu />
      </div>
    </header>
  );
};
